import {useDispatch, useSelector} from "react-redux";
import {
    selectWaypoints,
    updateDrive
} from "../../object/drycleaningMapObjectSlice";
import {useEffect, useState} from "react";
import styles from './Content.module.css';
import {Input} from "@material-ui/core";
import Select from "react-select";
import DateFnsUtils from "@date-io/moment";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import moment from "moment";
import {Button} from "react-bootstrap";
import _ from 'lodash'
import axios from "axios";
import {updateDriveInRoute} from "../../route/routeSlice";

const Transportation = ({drive}) => {
    const dispatch = useDispatch();
    const waypoints = useSelector(selectWaypoints)
    const transportation = drive.transportation;
    const [transportationDate, setTransportationDate] = useState(moment(transportation.date, 'DD-MM-YYYY'));
    const [transportationStartWayPoint, setTransportationStartWayPoint] = useState(transportation.startWayPoint);
    const [transportationFinishWayPoint, setTransportationFinishWayPoint] = useState(transportation.finishWayPoint);
    const [isSaved, setIsSaved] = useState(false);
    const driveStatusCompleted = 3;
    const driveStatusCanceled = 4;
    const isReadOnly = [driveStatusCompleted, driveStatusCanceled].includes(drive.status_id);

    useEffect(() => {
        setTransportationStartWayPoint(drive.transportation.startWayPoint)
        setTransportationFinishWayPoint(drive.transportation.finishWayPoint)
    }, [drive]);

    const formatedDate = transportationDate.format("YYYY-MM-DD");
    const date = isReadOnly ?
        <span className={styles.ContentBody__fieldStatic}>{formatedDate}</span>
        :
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={'ru'}>
            <DatePicker
                value={formatedDate}
                onChange={(e) => {
                    setTransportationDate(e);
                }}
                disableToolbar
                autoOk
                variant={'inline'}
                format={'YYYY-MM-DD'}
            />
        </MuiPickersUtilsProvider>

    const save = () => {
        const request = axios.put("/lsystem/api/v1/transportation/" + transportation.id, {
            order_id: transportation.orderNumber,
            drive_id: drive.id,
            start_way_point_id: transportationStartWayPoint.id,
            finish_way_point_id: transportationFinishWayPoint.id,
            date: transportationDate.format('DD-MM-YYYY'),
        })

        request.then((response) => {
            setIsSaved(true);
            dispatch(updateDrive({
                drive: drive,
                attributes: {
                    transportation: response.data
                }
            }))
            dispatch(updateDriveInRoute({
                drive: drive,
                attributes: {
                    transportation: response.data
                }
            }));
        })
    }

    const wayFrom = isReadOnly ? <span className={styles.ContentBody__fieldStatic}>{ transportationStartWayPoint.name }</span>
        :
        <Select
            value={{value: transportationStartWayPoint.id, label: transportationStartWayPoint.name}}
            options={waypoints.map((waypoint) => ({value: waypoint.id, label: waypoint.name}))}
            onChange={(e) => {
                setTransportationStartWayPoint(_.find(waypoints, {id: e.value}))
            }}
        />

    const wayTo = isReadOnly ?
        <span className={styles.ContentBody__fieldStatic}>{transportationFinishWayPoint.name}</span>
        : <Select
            value={{value: transportationFinishWayPoint.id, label: transportationFinishWayPoint.name}}
            options={waypoints.map((waypoint) => ({value: waypoint.id, label: waypoint.name}))}
            onChange={(e) => {
                setTransportationFinishWayPoint(_.find(waypoints, {id: e.value}))
            }}
        />

    const saveButton = isReadOnly ? '' : <Button size={'sm'} variant={"success"} onClick={save}>Сохранить</Button>

    return (
        <div key={drive.id} className={styles.ContentBody}>
            <h5>Перевозка с фабрики</h5>
            {isSaved ? <span style={{"color": "green", "display": "block"}}>Перевозка сохранена</span> : null}
            <label className={styles.ContentBody__label}>
                <div>Номер заказа</div>
                <Input defaultValue={transportation.orderNumber} readOnly={true}/>
            </label>

            <label className={styles.ContentBody__label}>
                <div>Откуда</div>
                {wayFrom}
            </label>

            <label className={styles.ContentBody__label}>
                <div>Куда</div>
                {wayTo}
            </label>

            <label className={styles.ContentBody__label}>
                <div>Дата</div>
                {date}
            </label>

            <label className={styles.ContentBody__label}>
                <div>Вещи</div>

                {transportation.goods.map((good, key) => (
                    <Button style={{"margin": "0 5px 5px 0"}}
                            key={key}
                            size={'sm'} variant={"primary"}>{good.name} ({good.qty})</Button>
                ))}
            </label>
            <br/>

            {saveButton}
        </div>
    );
}

export default Transportation;
